import { render, staticRenderFns } from "./cookie-consent.vue?vue&type=template&id=2d8a71af&"
import script from "./cookie-consent.vue?vue&type=script&lang=js&"
export * from "./cookie-consent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports